

















































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import axios from "axios";
import ModalChangeDPJP from "../modal/ModalChangeDPJP.vue";
import PasienMultiWarningIndicator from "@/components/icons/PasienMultiWarningIndicator.vue";
import moment from "moment";
import SvcBilling from "@/services/Billing";
import { storePasien } from "@/store/modules/pasien";
import { PasienTagByRm } from "@/types/daftarPasienPenunjang";
import { tagIndicatorByRm } from "@/utils/pasienTag";

const API_THIWUL = process.env.VUE_APP_API_THIWUL;

@Component({
  components: {
    ModalChangeDPJP,
    PasienMultiWarningIndicator
  }
})
export default class CardListPasienPenunjang extends Vue {
  @Prop() readonly pasien!: Array<{
    pasien: {
      rm: string;
      nama: string;
    };
  }>;
  @Prop() readonly poli!: string;
  @Prop({ type: Object, default: () => ({}) })
  readonly pasienTagByRm!: PasienTagByRm;
  @Prop() errListPx!: string;
  @Prop() loading!: boolean;
  status = "warning";

  dr = "";
  data = {};
  modalOpen = false;
  alertOpen = false;
  dtReg: object = {};
  page = "tab-soap";
  err: object = {};
  sess_login = this.stateuser;
  searchPx = "";

  unitActiveId = this.poli ? this.poli["unit_id"] : null;

  created() {}
  loadingSEPReg = null;

  get unitSibling() {
    if (["59", "60", "62", "68"].includes(this.stateuser.unit_id)) {
      return [
        {
          kode: "59",
          nama: "Pav. Yudhistira 1"
        },
        {
          kode: "60",
          nama: "Pav. Kresna 2"
        },
        {
          kode: "62",
          nama: "Pav. Kresna 1"
        },
        {
          kode: "68",
          nama: "Pav. Yudhistira 2"
        }
      ];
    } else {
      return [];
    }
  }

  @Watch("unitActiveId")
  changeUnitActiveId(val) {
    const newUnit = this.unitSibling.find(item => item.kode == val);

    if (newUnit) {
      userModule.changeSessionUnit({
        kode: newUnit.kode,
        nama: newUnit.nama,
        unit_group_id: null,
        zona: null
      });

      this.$nextTick(() => {
        this.reloadListPx();
      });
    }
  }

  get isUnitHasSibling() {
    return ["59", "60", "62", "68"].includes(this.stateuser.unit_id);
  }

  get listPasien() {
    const cari = (this.searchPx || "").toLowerCase();

    return (this.pasien || []).filter(item => {
      const nama = String((item.pasien && item.pasien.nama) || "").toLowerCase();
      const rm = String((item.pasien && item.pasien.rm) || "");

      return nama.includes(cari) || rm.includes(cari);
    });
  }

  get tagIndicatorByRm(): Record<string, string[]> {
    return tagIndicatorByRm(
      this.pasienTagByRm,
      storePasien.pasientTagAttribute
    );
  }

  get screen() {
    if (this.$vuetify.breakpoint.lgAndDown) return "non";
    else return "default";
  }

  get btnRefreshColor() {
    return this.errListPx == "1" ? "error" : "primary";
  }

  get headers() {
    const headers = [
      { text: "No. RM", value: "pasien.rm" },
      { text: "Nama", value: "pasien.nama", width: "20vh" },
      {
        text: "Indikator",
        value: "indikator",
        align: "center",
        sortable: false,
        width: "8vh"
      },
      { text: "Jk", value: "pasien.sex" },
      // { text: "Umur (th)", value: "pasien.umur", align: "center" },
      { text: "Alamat", value: "pasien.alamat" },
      { text: "Register", value: "register_id" },
      { text: "No. Order", value: "order_number", width: "14vh" },
      { text: "Tanggal", value: "tgl_in", width: "15vh" },
      { text: "Jam", value: "jam", align: "center" },
      { text: "Asal Unit", value: "unit.nama", width: "20vh" },
      { text: "DPJP", value: "dokter.nama" },
      { text: "Jaminan", value: "cara_bayar.nama" },
      // { text: "Kelas", value: "kelas", align: "center" },
      // { text: "No. TT/ Kamar", value: "nomor", align: "center" },
      // { text: "No.SEP", value: "no_sep", width: "10%" },
      { text: "", value: "action" }
    ];

    return headers;
  }

  get stateuser() {
    return userModule.user;
  }

  showError(item) {
    this.alertOpen = true;
    this.err = {
      errorMsg: item,
      errorIcon: "mdi-alert-circle-outline"
    };
  }

  handleClick(item, row) {
    row.select(true);
    this.$emit("dataCM", { item: item });
  }
  reloadListPx() {
    this.$emit("reloadListPx", "0");
  }
  detailRiwayat(rm) {
    this.$router.push({
      name: `detail-pasien`,
      params: {
        rm: rm
      }
    });
  }

  goToPemeriksaan(regId, rm, page = null) {
    this.$router.push({
      name: `pemeriksaan-ranap`,
      params: {
        register: regId,
        rm: rm,
        page: page
      }
    });
  }

  getPasienRelativeUmur(umur: any) {
    if (umur.th) {
      return `${umur.th} th`;
    } else if (umur.bln) {
      return `${umur.bln} bln`;
    } else {
      return `${umur.hr} hr`;
    }
  }

  async previewSepRanap(noReg) {
    this.loadingSEPReg = noReg;
    const listBerkas = await axios
      .get(`${API_THIWUL}/list-berkas/reg/${noReg}`)
      .then(dt => dt.data);

    const sep = listBerkas.data.find(item => item.id == 1102 && item.ket == 1);

    this.loadingSEPReg = null;

    if (sep && sep.link.length > 0) {
      window.open(sep.link[0], "__blank");
    } else {
      alert(
        "Berkas SEP Ranap tidak tersedia atau belum diunggah. Silahkan hubungi Admisi/ TPP..."
      );
    }
  }

  showModalChangeDpjp = false;
  dtDokter = {
    id: "",
    nama: ""
  };
  date = moment().format("YYYY-MM-DD");

  changeDokter(item) {
    this.showModalChangeDpjp = true;
    // console.log(item);
    this.dtDokter = item.dokter;
    this.dtReg = {
      register: item.register_id,
      tgl: this.date
    };
  }

  getListPasien() {
    this.$emit("reloadListPx");
  }

  billingData: null | Array<any> = null;
  loadingBillingReg = null;
  isBillingInfoModalShow = false;

  get totalTarifBilling() {
    return this.billingData?.reduce(
      (sumed, a) => sumed + parseInt(a.subtotal),
      0
    );
  }

  async showBillingRegister(regId) {
    await this.getBillingByRegister(regId);

    this.isBillingInfoModalShow = true;
  }

  async getBillingByRegister(regId) {
    this.loadingBillingReg = regId;

    const resp = await SvcBilling.getTindakanbyReg(regId)
      .then(resp => {
        return resp.data;
      })
      .finally(() => {
        this.loadingBillingReg = null;
      });

    const data = resp.sort((a, b) => {
      const tgl = new Date(a.tanggal).getTime() - new Date(b.tanggal).getTime(),
        jam =
          parseInt(a.jam.trim().padEnd(4, "0")) -
          parseInt(b.jam.trim().padEnd(4, "0"));

      return tgl || jam;
    });

    this.billingData = data;
  }

  @Watch("isBillingInfoModalShow")
  changeIsBillingInfoModalShow(val) {
    if (!val) {
      this.billingData = null;
    }
  }

  formatTarif(number) {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumSignificantDigits: 12
    }).format(number);
  }
}
